export default "__VITE_PUBLIC_ASSET__0fc6811d__"